import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faBriefcase,
  faChartLine,
  faCode,
  faLocationDot,
  faPenRuler,
} from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

import GetInTouch from "../../components/GetInTouch/GetInTouch";
import logo from "../../images/AxiomosLogo.png";

import "./Career.css";

const careerAreas = [
  {
    id: "engineering",
    icon: faCode,
    title: "Software Engineering",
    description:
      "Build dependable web, mobile, cloud, and enterprise products using modern engineering practices.",
  },
  {
    id: "design",
    icon: faPenRuler,
    title: "Product & Design",
    description:
      "Turn complex requirements into clear, accessible, and meaningful digital experiences.",
  },
  {
    id: "growth",
    icon: faChartLine,
    title: "Business & Growth",
    description:
      "Create partnerships, understand client challenges, and help valuable technology reach the right organisations.",
  },
];

function Career() {
  const whatsappMessage = encodeURIComponent(
    "Hi Axiomos team, I am interested in career opportunities at Axiomos Technologies LLP. Please let me know how I can apply.",
  );

  return (
    <main className="career-page">
      <section className="career-hero" aria-labelledby="career-page-title">
        <div className="career-hero__decoration" aria-hidden="true" />

        <div className="career-hero__container">
          <div className="career-hero__content">
            <span className="career-hero__index" aria-hidden="true">
              AX / Careers
            </span>

            <div className="career-hero__heading">
              <p className="career-hero__eyebrow">
                <span aria-hidden="true" />
                Build your future with us
              </p>

              <h1 id="career-page-title">
                Do meaningful work. <span>Grow with purpose.</span>
              </h1>
            </div>

            <p className="career-hero__description">
              Join a team that combines responsible engineering, business
              understanding, and technology to solve practical challenges and
              create lasting value.
            </p>

            <div className="career-hero__actions">
              <a
                href="#career-opportunities"
                className="career-hero__primary-link"
              >
                Explore opportunities
                <span aria-hidden="true">
                  <FontAwesomeIcon icon={faArrowRight} />
                </span>
              </a>

              <a
                href={`https://wa.me/917738899255?text=${whatsappMessage}`}
                target="_blank"
                rel="noopener noreferrer"
                className="career-hero__secondary-link"
              >
                <FontAwesomeIcon icon={faWhatsapp} aria-hidden="true" />
                Speak with our team
              </a>
            </div>
          </div>

          <aside
            className="career-hero__brand-card"
            aria-label="Axiomos career information"
          >
            <div className="career-hero__brand-top">
              <span>Careers at</span>

              <img
                src={logo}
                className="career-hero__logo"
                alt="Axiomos Technologies LLP"
              />
            </div>

            <div className="career-hero__brand-message">
              <FontAwesomeIcon icon={faBriefcase} aria-hidden="true" />

              <p>
                We are always interested in meeting thoughtful people who want
                to build useful technology and grow with an ambitious team.
              </p>
            </div>

            <div className="career-hero__location">
              <FontAwesomeIcon icon={faLocationDot} aria-hidden="true" />

              <div>
                <small>Primary location</small>
                <strong>Pune, Maharashtra, India</strong>
              </div>
            </div>
          </aside>
        </div>
      </section>

      <section
        id="career-opportunities"
        className="career-opportunities"
        aria-labelledby="career-opportunities-title"
      >
        <div className="career-opportunities__container">
          <header className="career-opportunities__header">
            <div>
              <p className="career-opportunities__eyebrow">
                <span aria-hidden="true" />
                Career opportunities
              </p>

              <h2 id="career-opportunities-title">
                Find where your skills can create an impact.
              </h2>
            </div>

            <div className="career-opportunities__introduction">
              <p>
                Our requirements evolve as new projects and partnerships begin.
                Share your profile with us, and we will contact you when a
                suitable opportunity becomes available.
              </p>

              <span className="career-opportunities__status">
                <i aria-hidden="true" />
                Open applications
              </span>
            </div>
          </header>

          <div className="career-opportunities__grid">
            {careerAreas.map((area, index) => (
              <article className="career-area-card" key={area.id}>
                <div className="career-area-card__top">
                  <span className="career-area-card__icon" aria-hidden="true">
                    <FontAwesomeIcon icon={area.icon} />
                  </span>

                  <small aria-hidden="true">
                    Area / {String(index + 1).padStart(2, "0")}
                  </small>
                </div>

                <h3>{area.title}</h3>
                <p>{area.description}</p>

                <a
                  href={`https://wa.me/917738899255?text=${whatsappMessage}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="career-area-card__link"
                  aria-label={`Enquire about ${area.title} opportunities`}
                >
                  Express interest
                  <FontAwesomeIcon icon={faArrowRight} aria-hidden="true" />
                </a>
              </article>
            ))}
          </div>

          <div className="career-opportunities__cta">
            <div>
              <span aria-hidden="true">AX / Application</span>

              <h2>Do not see your exact role?</h2>

              <p>
                Send us your profile anyway. Strong people often create
                opportunities that did not previously exist.
              </p>
            </div>

            <a
              href={`https://wa.me/917738899255?text=${whatsappMessage}`}
              target="_blank"
              rel="noopener noreferrer"
              className="career-opportunities__cta-link"
            >
              <FontAwesomeIcon icon={faWhatsapp} aria-hidden="true" />
              Share your profile
              <FontAwesomeIcon icon={faArrowRight} aria-hidden="true" />
            </a>
          </div>
        </div>
      </section>

      <GetInTouch />
    </main>
  );
}

export default Career;
